import {
  auth,
  FirebaseUser,
  firestore,
  getCrendetials,
} from '../firebase/firebase';

export const signIn = async (email: string, password: string) => {
  const authUser = await auth.signInWithEmailAndPassword(email, password);
  return authUser;
};

export const snapshot = async (user: FirebaseUser) => {
  const userRef = await firestore.doc(`users/${user.uid}`).get();
  const users = userRef.data();

  return users;
};

export const signOut = () => {
  return auth.signOut();
};

export const changePassword = async (
  user: FirebaseUser,
  newPassword: string
) => {
  const changePass = await user.updatePassword(newPassword);
  return changePass;
};

export const reauthProcess = async (
  user: FirebaseUser,
  { email, password }: { email: string; password: string }
) => {
  const credential = getCrendetials(email, password);
  const reauth = await user.reauthenticateWithCredential(credential);
  return reauth;
};
